import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) 
{
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",
  //mode: "abstract",
  scrollBehviour(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
});

function storageAvailable(type) 
{
  try {
    var storage = window[type],
      x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    //console.log(35,'storageTest')
    return true;
  }
  catch(e) {
    return false;
  }
}

/*
if(!storageAvailable('localStorage'))
{
  //next({path: '/auth/storageissue', params: { nextUrl: to.fullPath }})
  console.log(47,'storageIssue');
  router.beforeEach((to, from, next) => 
  {
    next({path: '/auth/storageissue', params: { nextUrl: to.fullPath }})
  });
}
else
{
  let level=0;
  if ('settings' in sessionStorage){
    if (sessionStorage.getItem('settings')=== 'undefined')
    {
      sessionStorage.removeItem('settings')
    }
    else{
      level = parseInt(JSON.parse(sessionStorage.getItem('settings')).level)
    }
  }
  */
  //console.log(61,localStorage.getItem('user'))
  /*
  let level_b=0;
  if ('user_b' in localStorage){
    level_b = parseInt(JSON.parse(localStorage.getItem('user_b')).level)
  }
  */

  router.beforeEach((to, from, next) => 
  {
    //console.log(70,to);
    //console.log(71,from);
    if(!storageAvailable('localStorage'))
    {
      next({path: '/auth/storageissue', params: { nextUrl: to.fullPath }})
    }
    else
    {
      var target=sessionStorage.getItem('target');
      //var level = parseInt(JSON.parse(sessionStorage.getItem('settings')).level)

      if(to.matched.some(record => record.meta.requiresAuth)) // requires log
      {
        if (!sessionStorage.getItem('jwt') || !JSON.parse(sessionStorage.getItem('settings'))) // is not logged
        {
          //console.log('router_localStorage:user:',localStorage.getItem('user') == null)
          if(sessionStorage.getItem('settings') == null) // not remembered
          {
            next({path: '/auth/login', params: { nextUrl: to.fullPath } })
          }
          else
          {
            if (JSON.parse(sessionStorage.getItem('settings')).email == null) // remembered bt missing email
            {
              next({path: '/auth/login', params: { nextUrl: to.fullPath } })
            }
            else                                                              // remembered => lockscreen
            {
              next({path: '/auth/lockscreen', params: { nextUrl: to.fullPath } })
            }
          }
        }
        else // is logged
        {
          let level = parseInt(JSON.parse(sessionStorage.getItem('settings')).level);
          //console.log(97,level);
          if (to.matched.some(record => record.meta.bossOnly)) 
          {
            if(level>100)
            {
              //console.log(103,target,to.fullPath);
              if (target)
              {
                sessionStorage.removeItem('target');
                next({path: target, params: { nextUrl: to.fullPath }})
              }
              else
              {
                next()
              }
            }
            else
            {
              next({path: '/error/403', params: { nextUrl: to.fullPath }})
            }
          }
          else
          {
            //console.log(121,target,to.fullPath);
            if (target)
            {
              sessionStorage.removeItem('target');
              next({path: target, params: { nextUrl: to.fullPath }})
            }
            else
            {
              next()
            }
          }
        }
      } 
      else // login not required
      { 
        //console.log(151,window.location.host.toLowerCase())
        //console.log(152,window.location.pathname);
        //console.log(153,to.path,to.query);
        if(window.location.host.toLowerCase()+window.location.pathname=='ibookrestaurant.com/'&&to.path!='/auth/login')
        //if(window.location.host.toLowerCase()+window.location.pathname=='aibooking.cloud/'&&to.path!='/auth/login')
        //var wlh=window.location.host.toLowerCase();
        //if((wlh=='aibooking.cloud'||wlh=='ibookrestaurant.com')&&to.path!='/auth/login')
        {
          //console.log(156,window.location,to)
          next({path: '/auth/login', params: { nextUrl: to.fullPath } })
        }
        else
        {
          if (to.path=='/payment')
          {
            //console.log(156,window.location,to)
            next({path: '/settings/?pageId=services', params: { nextUrl: to.fullPath } })
          }
          else
          {
            next()
          }
        }
      }
    }
  });

  router.afterEach(() => {
    window.scrollTo(0, 0);
  });

export default router;
